import { Component, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { JournodexRegionsService } from '../../../Journodex/services/journodex-regions.service';
import { JournodexSubjectsService } from '../../../Journodex/services/journodex-subjects.service';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { LocalizedEnum } from '../../../../api/journodex/model/localized-enum';

import { JournodexEnumsService } from '../../../../Discover/Core/services/journodex-enums.service';
import { TargetingSearchesService } from '../../../../Discover/Targeting/services/targeting-searches.service';
import { TargetingListService } from '../../../../Discover/Targeting/services/targeting-list.service';
import { TargetingSearch } from '../../../../Discover/Targeting/models/targeting-search.model';
import { TargetingList } from '../../../../Discover/Targeting/models/targeting-list.model';

@Component({
    selector: 'agpr-targeting-search-summary',
    templateUrl: './search-summary.component.html',
    styleUrls: ['./search-summary.component.scss'],
    standalone: false
})
export class SearchSummaryComponent implements OnDestroy {

    @Input() targetingSearch: TargetingSearch;
    @Input() targetingList: TargetingList;

    circulationNameMap: Map<string, string>;

    private circulationTypes: LocalizedEnum[];
    private subscriptions: Subscription[] = [];

    constructor(
        public localizationService: LocalizationService,
        public journodexSubjectsService: JournodexSubjectsService,
        public targetingSearchesService: TargetingSearchesService,
        public targetingListService: TargetingListService,
        public journodexEnumsService: JournodexEnumsService,
        public journodexRegionsService: JournodexRegionsService,
    ) {
        this.subscriptions.push(
            this.targetingListService.currentResource$.subscribe(targetingList => {
                this.targetingList = targetingList;
            }),
            this.journodexEnumsService.getCirculationTypes().pipe(filter(x => !!x)).subscribe(
                circulationTypes => {
                    this.circulationTypes = circulationTypes;
                    this.circulationNameMap = new Map(this.circulationTypes.map(x => [x.enumValue, x.displayString]));
                }
            )
        );
    }


    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
